/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupMutationResponse, UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupPathParams } from "../models/UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroup";

function getUsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupUrl(groupId: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupPathParams["groupId"], permission: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupPathParams["permission"]) {
  const res = { method: 'POST', url: `/admin/group/${groupId}/permissions/${permission}/deny` as const }  
  return res
}

/**
 * @summary Deny a permission for a group
 * {@link /admin/group/:groupId/permissions/:permission/deny}
 */
export async function usersAuthzAPIAdminPermissionsWriteDenyPermissionToGroup(groupId: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupPathParams["groupId"], permission: UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupPathParams["permission"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getUsersAuthzAPIAdminPermissionsWriteDenyPermissionToGroupUrl(groupId, permission).url.toString(), ... requestConfig })  
  return res.data
}